<div class="row">
  <div *ngIf="title" class="title col-12">{{ title | translate }}</div>
  <app-shop-product *ngFor="let product of products" class="item col-lg-6 col-xga-4 col-xl-6 col-sm-6 col-md-6 pb-4"
    [product]="product" [hideProductName]="hideProductName" (productClick)="onProductClick($event)"></app-shop-product>
</div>
